<template>
  <div style="padding-top: 10px">
    <!--<title-card title="数据中心" style="max-width: 97%; margin: 10px auto">
      <div style="position: absolute; right: 70px">
        &lt;!&ndash;<el-button type="primary" size="mini">创建选品库</el-button>&ndash;&gt;
      </div>
    </title-card>-->
    <div id="kt_content_container" class="ms-10"
         style=" max-width: 97%; flex-direction: row !important; display: flex; ">
      <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
        <div class="d-flex flex-column flex-column-fluid">
          <div id="kt_app_content" class="app-content" style="padding-top: 0px">
            <div class="card card-flush">
              <div class="card-body" style="padding: 17px 17px">
                <!-- 父-->
                <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-4 fw-semibold mb-15"
                    style="margin-bottom: 0 !important; position: relative">
                  <li v-for="(item, i) in orderStatus" :key="i" class="nav-item">
                    <a :class="index === i + 1 ? 'active' : ''" :href="`#kt_tab_pane_${i + 1}`"
                       class="nav-link text-active-primary d-flex align-items-center pb-5"
                       data-bs-toggle="tab" @click="index = i + 1"
                       style="font-size: 13px; font-weight: bold">
                      <i v-html="item.icon"></i>{{ item.title }}</a>
                  </li>
                </ul>
                <!--    爬虫机器中心     -->
                <div v-if="index === 1">
                  <div style="position: absolute; right: 70px">
                    <!--<el-button type="primary" size="mini">创建选品库</el-button>-->
                  </div>
                  <div class="mt-5">
                    爬虫机器状态数量：
                    <el-tag
                        effect="plain"
                        type="success">
                      正常: {{ normal }}
                    </el-tag>
                    <el-tag
                        effect="plain"
                        style="margin-left: 10px" type="danger">
                      异常: {{ abnormal }}
                    </el-tag>
                  </div>
                  <div style="max-width: 97%; margin: 10px auto;background: #fff;border-radius: 14px;min-height: 87vh;padding: 10px">
                    <el-table
                        :data="rows"
                        style="width: 100%">
                      <el-table-column
                          label="ID"
                          prop="id">
                      </el-table-column>
                      <el-table-column
                          label="TodeskID"
                          prop="todeskNum">
                      </el-table-column>
                      <el-table-column label="状态">
                        <template slot-scope="scope">
                          <el-tag
                              v-if="scope.row.state==1 && scope.row.pcStatus"
                              effect="dark"
                              size="mini" type="success">
                            正常
                          </el-tag>
                          <el-tag
                              v-else
                              effect="dark"
                              size="mini" type="danger">
                            异常
                          </el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="电脑状态">
                        <template slot-scope="scope">
                          <el-tag
                              v-if="scope.row.pcStatus"
                              effect="dark" size="mini">
                            在线
                          </el-tag>
                          <el-tag
                              v-else
                              effect="dark"
                              size="mini" type="info">
                            离线
                          </el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="">
                        <template slot-scope="scope">
                          <div v-if="s==0" v-loading="s==0">
                            刷新成功
                          </div>
                          <div v-if="s!=0">
                            {{ s }}秒后刷新
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <!-- 爬虫机器结束 -->
                <!--    商品下载中心    -->
                <div v-if="index === 2">
                  <!-- 子 -->
                  <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-4 fw-semibold mb-15"
                      style="margin-bottom: 0 !important; position: relative">
                    <li v-for="(item, i) in productDownload" :key="i" class="nav-item">
                      <a :class="productIndex === i + 1 ? 'active' : ''" :href="`#kt_tab_pane_${i + 1}`"
                         class="a-black text-active-dark d-flex align-items-center pb-5"
                         data-bs-toggle="tab" @click="productIndex = i + 1"
                         style="font-size: 13px; font-weight: bold">
                        <i :class="item.icon"></i>{{ item.title }}</a>
                    </li>
                  </ul>

                  <Category v-if="productIndex === 1" ref="Category"></Category>
                  <Pool v-if="productIndex === 2" ref="Pool"></Pool>
                  <Brand v-if="productIndex === 3" ref="Category"></Brand>
                  <SearchJdGoods v-if="productIndex === 4" ref="Category"></SearchJdGoods>
                </div>
                <!-- 商品下载中心结束 -->

                <div v-if="index === 3">
                  <XiTunBaoSelectedGoods  ref="XiTunBaoSelectedGoods"></XiTunBaoSelectedGoods>
                </div>

                <div v-if="index === 4">
                  <!-- 子 -->
                  <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-4 fw-semibold mb-15"
                      style="margin-bottom: 0 !important; position: relative">
                    <li v-for="(item, i) in goodsPriceChart" :key="i" class="nav-item">
                      <a :class="goodsPriceIndex === i + 1 ? 'active' : ''" :href="`#kt_tab_pane_${i + 1}`"
                         class="a-black text-active-dark d-flex align-items-center pb-5"
                         data-bs-toggle="tab" @click="goodsPriceIndex = i + 1"
                         style="font-size: 13px; font-weight: bold">
                        <i v-html="item.icon"></i>{{ item.title }}</a>
                    </li>
                  </ul>

                  <GoodsPriceTrend v-if="goodsPriceIndex === 1" ref="GoodsPriceTrend"></GoodsPriceTrend>
                  <GoodsLowestBuy v-if="goodsPriceIndex === 2" ref="GoodsLowestBuy"></GoodsLowestBuy>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {getIdcListApi} from "@/api/admin/idcApi";

import Brand from "@/views/IDC/components/Brand/Brand.vue";
import Category from "@/views/IDC/components/Category/Category.vue";
import Pool from "@/views/IDC/components/Pool/Pool.vue";
import XiTunBaoSelectedGoods from "@/views/IDC/components/XiTunBaoSelectedGoods/XiTunBaoSelectedGoods.vue";
import GoodsPriceTrend from "@/views/IDC/components/GoodsPriceTrend/GoodsPriceTrend.vue";
import GoodsLowestBuy from "@/views/IDC/components/GoodsLowestBuy/GoodsLowestBuy.vue";
import SearchJdGoods from "@/views/IDC/components/SearchJdGoods/index.vue";
//import {poolMixins} from "@/views/IDC/poolMixins";
//import {brandMixins} from "@/views/IDC/brandMixins";
//import {categoryMixins} from "@/views/IDC/categoryMixins";

export default {
  //mixins: [poolMixins, brandMixins, categoryMixins],
  components: {
    Brand,
    Category,
    Pool,
    XiTunBaoSelectedGoods,
    GoodsPriceTrend,
    GoodsLowestBuy,
    SearchJdGoods
  },
  name: 'IDC',
  data() {
    return {
      rows: [],
      s: 10,
      interval: null,
      index: 1,
      orderStatus: [
        {
          title: "爬虫机器中心",
          count: 0,
          //icon: "ki-outline ki-bookmark-2 fs-5 me-2",
          icon: "<svg t=\"1717145340294\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"4127\" width=\"16\" height=\"16\"><path d=\"M964.064 651.04L894.56 190.784C891.84 156.192 861.344 128 824.672 128H203.68a70.336 70.336 0 0 0-70.112 64.64L64.32 640.928l-0.32 4.896 3.392 158.464 0.896 3.328a70.304 70.304 0 0 0 67.872 51.936h756.544c31.296 0 58.848-20.704 67.552-50.752l1.056-3.584 3.04-149.408-0.288-4.768zM189.376 199.2c0.832-9.344 6.944-14.976 14.272-14.976H824.64a14.08 14.08 0 0 1 14.016 12.96l62.208 412.16H126.112L189.376 199.2z m715.872 596.48a14.08 14.08 0 0 1-12.512 7.616H136.192a14.08 14.08 0 0 1-12.704-8l-2.816-129.664h787.232l-2.656 130.048z\" fill=\"#231916\" p-id=\"4128\"></path><path d=\"M753.216 775.008h84.352a28.16 28.16 0 0 0 0-56.256h-84.352a28.16 28.16 0 0 0 0 56.256zM640.736 775.008h14.048a28.16 28.16 0 0 0 0-56.256h-14.048a28.16 28.16 0 0 0 0 56.256zM528.256 775.008h14.048a28.16 28.16 0 0 0 0-56.256h-14.048a28.16 28.16 0 0 0 0 56.256z\" fill=\"#231916\" p-id=\"4129\"></path></svg>",
        },
        {
          title: "商品下载中心",
          count: 0,
          //icon: "ki-outline ki-note-2 fs-5 me-2",
          icon: "<svg t=\"1717145380512\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"6032\" width=\"16\" height=\"16\"><path d=\"M738.7 61H285.3c-113.1 0-205 92-205 205v492c0 113.1 92 205.1 205.1 205.1h453.4c113.1 0 205.1-92 205.1-205.1V266c-0.2-113-92.1-205-205.2-205z m150.7 697c0 83.1-67.6 150.7-150.7 150.7H285.3c-83.1 0-150.7-67.6-150.7-150.7V266c0-83.1 67.6-150.7 150.7-150.7h453.4c83.1 0 150.7 67.6 150.7 150.7v492z\" fill=\"#494949\" p-id=\"6033\"></path><path d=\"M646.3 402.2c-24.2-52.4-77-86.1-134.9-86.1-58 0-110.8 33.8-135 86.4-49.9 8.5-88.8 54.2-88.8 104.8 0 58.6 47.7 106.3 106.3 106.3h33.6c12.4 0 22.5-10.1 22.5-22.5s-10.1-22.5-22.5-22.5h-33.6c-33.8 0-61.4-27.5-61.4-61.4 0-33.1 27-60.7 60.1-61.3 9.4-0.2 17.7-6.3 20.8-15.1 14.5-41.8 53.9-69.8 98.1-69.8 44.2 0 83.6 28 98.1 69.8 3.1 9 11.6 15 21.1 15.1 33.6 0.2 61 27.7 61 61.4 0 32.5-25.4 59.4-57.8 61.3-0.4 0-0.8 0-1.1 0.1h-36.1c-12.4 0-22.5 10.1-22.5 22.5s10.1 22.5 22.5 22.5H635c1 0 2.9-0.1 3.6-0.3 54.9-4.3 97.9-50.9 97.9-106 0-51.5-39.5-97.3-90.2-105.2z\" fill=\"#494949\" p-id=\"6034\"></path><path d=\"M566.7 659.1c-5.3 0-10.4 2.1-13.9 5.6l-19.9 19.9V570.1c0-10.8-8.8-19.7-19.7-19.7-10.8 0-19.7 8.8-19.7 19.7v114.5l-19.9-19.9c-7.2-7.2-20.7-7.2-27.8 0-3.7 3.7-5.8 8.7-5.8 13.9 0 5.3 2 10.2 5.8 13.9l53.4 53.4c0.9 0.9 2 1.8 3.5 2.8l1.2 0.7c0.6 0.3 1.1 0.6 1.7 0.9 0.6 0.2 1.1 0.4 2.3 0.8l1.4 0.4c1.3 0.3 2.5 0.4 3.8 0.4 1.3 0 2.6-0.1 3.9-0.4 0.5-0.1 0.9-0.2 1.8-0.5l1.8-0.6c0.6-0.2 1.1-0.5 2.2-1.1l1.3-0.7c1.1-0.7 2.1-1.6 3-2.4l53.5-53.5c3.7-3.7 5.8-8.7 5.8-13.9 0-5.3-2-10.2-5.8-13.9-3.6-3.7-8.6-5.8-13.9-5.8z\" fill=\"#494949\" p-id=\"6035\"></path></svg>",
        },
        {
          title: "喜豚宝商品数据精选",
          count: 0,
          icon: `<svg t="1717142285083" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2434" width="16" height="16"><path d="M695.34304 216.672834c13.37108 0 26.74216-5.849847 35.099085-15.878158-5.014155 1.671385-10.02831 2.507077-15.042465 2.507078-21.728005 0-39.277547-17.549542-39.277547-39.277547s17.549542-39.277547 39.277547-39.277547c-24.235082-10.864002-52.648627-0.835692-63.51263 23.399389s-0.835692 52.648627 23.39939 63.51263c6.68554 3.34277 13.37108 5.014155 20.05662 5.014155z m4.178462-67.691092c0 5.849847 5.014155 10.864002 10.864003 10.864002s10.864002-5.014155 10.864002-10.864002c0-5.849847-5.014155-10.864002-10.864002-10.864003-5.849847 0-10.864002 5.014155-10.864003 10.864003z m273.271445 549.885659s-3.34277-63.512629-66.855399-63.512629c-37.606162 0-67.691092 30.08493-67.691092 67.691092v13.37108c0 110.311409-89.419097 200.566198-200.566198 200.566198-96.940329 2.507077-181.345271-66.019707-198.894813-161.288651 0.835692 3.34277-16.71385-51.812934 6.68554-139.560646 2.507077-10.864002 6.68554-14.206772 4.178462-18.385235-0.835692-1.671385-6.68554 4.178462-6.685539 4.178462-48.470165 78.555094-29.249237 175.495423-30.08493 169.645576 17.549542 105.297254 91.090482 189.702196 202.237583 219.787125 5.014155 1.671385 10.02831 2.507077 15.042465 3.34277-5.849847 0-11.699695 0.835692-17.549543 0.835693-164.631421 0-295.835142-126.189566-295.835142-290.820987 0-106.968639 66.855399-212.265893 149.588956-254.88621 5.849847-2.507077 12.535387-4.178462 19.220928-5.014155 14.206772 3.34277 22.563697 5.849847 24.235082 24.235082 2.507077 25.070775-8.356925 40.948932-26.74216 61.005552-7.521232 7.521232-12.535387 14.206772-12.535387 14.206772-2.507077 7.521232 11.699695 7.521232 11.699695 7.521233 22.563697 0.835692 45.127395-4.178462 66.019706-14.206773 30.08493-15.878157 55.991397-38.441855 76.048017-66.019706 26.74216-35.099085 30.08493-84.404942 28.413545-110.311409 0-5.849847 4.178462-11.699695 14.206772-15.878158 27.577852-11.699695 49.305857-19.220927 60.16986-23.399389 30.920622-10.02831 66.019707-18.385235 89.419096-28.413545-10.02831-1.671385-20.892312-4.178462-30.920622-7.521233-35.099085-13.37108-41.784625-30.08493-41.784624-30.084929h5.849847c21.728005 10.864002 45.963087 16.71385 70.198169 17.549542 49.305857 0.835692 70.198169-10.864002 75.212324-13.37108 35.934777-18.385235 57.662782-48.470165 38.441855-83.569249-10.864002-20.892312-44.291702-25.906467-59.334167-25.906467-33.4277-0.835692-35.099085 2.507077-34.263392-18.385235 0 1.671385-1.671385-85.240634-100.283099-118.668334 3.34277 0.835692-123.682489-58.498474-311.713299 64.348322-41.784625 27.577852-80.226479 58.498474-114.489872 94.433252-30.920622-6.68554-76.883709-21.728005-148.753263-0.835693-85.240634 25.070775-108.640024 85.240634-108.640024 85.240634s-10.864002 30.920622-2.507078 33.4277c16.71385 5.849847 61.005552-30.08493 99.447407-15.878157 20.892312 5.849847 33.4277 27.577852 27.577852 48.470164-0.835692 2.507077-1.671385 5.014155-2.507077 6.68554-36.77047 68.526784-56.827089 145.410494-59.334167 223.129895-4.178462 241.51513 189.702196 466.31641 467.987795 471.330566 59.334167 0.835692 118.668334-9.192617 173.824038-30.08493 10.864002-4.178462 20.892312-8.356925 30.08493-13.37108 109.475716-40.948932 182.180963-146.246186 182.180963-263.243135 0.835692-5.849847 0-12.535387 0-18.385235zM695.34304 104.69004c35.099085 0 63.512629 28.413545 63.512629 63.512629s-28.413545 63.512629-63.512629 63.51263c-35.099085 0-63.512629-28.413545-63.512629-63.51263 0-35.099085 28.413545-63.512629 63.512629-63.512629z m-77.719402 762.987245c-22.563697 3.34277-45.127395 3.34277-66.855399 1.671385 43.45601 25.070775 98.611714 23.39939 148.753263 7.521232 69.362477-21.728005 111.147101-100.283099 112.818487-142.067724 0.835692-30.920622-1.671385-65.184014 19.220927-90.254789 15.042465-18.385235 35.934777-30.920622 59.334167-36.770469l-1.671385-7.521233s-15.042465-61.841244-77.719402-50.141549c-36.77047 6.68554-61.005552 41.784625-54.320012 78.555094 0.835692 2.507077 1.671385 9.192617 2.507078 12.535387 20.892312 109.475716-36.77047 206.416045-142.067724 226.472666z" fill="#d81e06" p-id="2435"></path></svg>`,
        },
        {
          title: "商品数据中心",
          count: 0,
          icon: `<svg t="1728548731764" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5679" width="16" height="16"><path d="M678.052728 341.367443c-3.172179-26.400719-17.907465-41.238333-44.410512-44.410513-15.553912 1.534926-27.321675 7.776956-34.996303 18.623764l-86.467473 123.817327-86.467473-123.817327c-8.80024-10.539822-21.386629-17.293495-34.996302-18.623764-28.037973 3.172179-42.875587 17.907465-44.410513 44.410513-1.534926 10.949136 1.534926 19.544719 9.41421 25.684421l74.69971 105.091236h-49.015289c-17.191166 3.069851-26.503048 11.767763-28.037973 25.684421 0 17.191166 9.41421 25.684421 28.037973 25.684421h86.467473v39.703407h-86.467473c-17.191166 3.069851-26.503048 11.665434-28.037973 25.684421 0 17.088838 9.41421 25.684421 28.037973 25.684421h86.467473v72.346158c0 26.503048 14.837614 39.703408 44.410513 39.703407 28.037973 0 42.875587-13.20036 44.410512-39.703407v-72.346158h86.467473c17.191166 0 26.503048-8.595583 28.037973-25.684421-3.172179-14.121315-12.484061-22.61457-28.037973-25.684421H556.691281v-39.703407h86.467473c17.191166 0 26.503048-8.493255 28.037973-25.684421-3.172179-14.018987-12.484061-22.61457-28.037973-25.684421h-49.015289l74.802038-105.091236c6.037374-6.139702 9.107225-14.735285 9.107225-25.684421z m-539.27051 213.45698c17.907465-6.651344 29.777556-23.740182 29.777555-42.773259 0-194.526232 158.301989-352.82822 352.828221-352.82822 125.966224 0.306985 242.211252 67.332068 305.552513 176.311782 12.688718 21.795943 40.624363 29.265914 62.420306 16.577196 21.795943-12.688718 29.265914-40.624363 16.577196-62.420306-79.611472-137.120016-226.04337-221.540921-384.550015-221.847907-207.82892 0-382.708104 143.362047-430.904767 336.455681l-10.130509-11.767762c-16.474868-19.033077-45.331468-21.181973-64.466873-4.707105-19.135405 16.474868-21.284301 45.331468-4.809433 64.364545l77.155591 89.537324c12.58639 14.530629 32.745078 19.749375 50.550215 13.098031zM885.165349 469.175577c-17.907465 6.651344-29.777556 23.740182-29.777555 42.875587 0 194.526232-158.301989 352.82822-352.828221 352.82822-125.966224-0.306985-242.31358-67.434396-305.552513-176.311781-12.688718-21.795943-40.624363-29.265914-62.420306-16.577196-21.795943 12.688718-29.265914 40.624363-16.577196 62.420306 79.611472 137.017688 226.04337 221.540921 384.652344 221.847906 207.82892 0 382.708104-143.464375 431.007095-336.558009l10.130508 11.767762c16.474868 19.135405 45.331468 21.284301 64.364545 4.809434 19.135405-16.474868 21.284301-45.331468 4.809434-64.364545l-77.155591-89.639653C923.129175 467.640652 902.970486 462.524233 885.165349 469.175577z m0 0" fill="" p-id="5680"></path></svg>`,
        },
      ],
      productIndex: 1,
      productDownload: [
        {
          title: "京东分类数据",
          count: 0,
          //icon: "ki-outline ki-bookmark-2 fs-5 me-2",
          icon: "el-icon-s-operation",
        },
        {
          title: "商品池数据",
          count: 0,
          //icon: "ki-outline ki-note-2 fs-5 me-2",
          icon: "el-icon-goods fs-5 me-2",
        },
        {
          title: "京东品牌数据",
          count: 0,
          //icon: "ki-outline ki-bookmark-2 fs-5 me-2",
          icon: "el-icon-s-check fs-5 me-2",
        },
        {
          title: "自定义下载",
          count: 0,
          //icon: "ki-outline ki-bookmark-2 fs-5 me-2",
          icon: "el-icon-download fs-5 me-2",
        }
      ],
      goodsPriceIndex: 1,
      goodsPriceChart: [
        {
          title: "商品价格三维折线图",
          count: 0,
          //icon: "ki-outline ki-bookmark-2 fs-5 me-2",
          icon: `<svg t="1728627168476" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7876" width="16" height="16"><path d="M447.872 534.72l331.904 332.864c-55.936 41.984-121.856 72.896-193.728 85.76-0.32 0.064-0.64 0.064-1.024 0.128C561.28 957.76 536.832 960 511.872 960 265.088 960 65.024 757.184 64 510.08c0.96-224.768 167.488-409.92 383.872-441.024L447.872 534.72zM547.904 530.048l288.96 289.792c76.032-80.32 123.072-188.48 123.072-307.904L565.888 511.936 547.904 530.048zM512 192l128 0 0 64L512 256l0 64 128 0 0 64L512 384l0 64 128 0 64 0L704 192 704 128 512 128 512 192zM832 192l64 0L896 128l-128 0 0 64 0 256 64 0 64 0L896 384l-64 0L832 192zM896 192l0 192 64 0L960 192 896 192z" fill="#010101" p-id="7877"></path></svg>`,
        },
        {
          title: "商品最低起售数量",
          count: 0,
          //icon: "ki-outline ki-note-2 fs-5 me-2",
          icon: `<svg t="1728627269593" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13845" width="16" height="16"><path d="M192 832V128h-64v768h768v-64z" p-id="13846"></path><path d="M605.6 640l-184-161.6L299.2 632l-50.4-40 164.8-206.4 184.8 163.2 248.8-296.8 48.8 40.8z" p-id="13847"></path></svg>`,
        },
      ]
    }
  },
  computed: {
    normal() {
      let a = 0;
      this.rows.forEach(element => {
        if (element.state === 1 && element.pcStatus) {
          a++
        }
      });
      return a
    },
    abnormal() {
      let a = 0;
      this.rows.forEach(element => {
        if (!(element.state == 1 && element.pcStatus)) {
          a++
        }
      });
      return a
    }
  },
  methods: {
    async getList() {
      let {data} = await getIdcListApi();
      for (let index = 0; index < data.rows.length; index++) {
        const element = data.rows[index];
        data.rows[index].pcStatus = await this.getSurvival(element.id)
      }
      this.rows = data.rows;
    },
    async getSurvival(id) {
      //let {data} = await getSurvivalApi({id})
      // return data;
    },
  },
  created() {
    // this.getList();
    this.interval = setInterval(() => {
      if (this.s == 0) {
        // this.getList()
        this.s = 10
      } else {
        this.s--
      }
    }, 1000)
  },
  activated() {

  },
  destroyed() {
    clearTimeout(this.interval)
  },
  deactivated() {

  },
}
</script>
